import { App } from '../App';
import { DEFAULT_TERM } from './constants';
import { getAmountAndTermCalculator } from '../hooks/useApplicationSummary';
import { Response as ResponseConstraints } from '../api/typegen/client/application/constraints/get';
import { Response as ResponseOffer } from '../api/typegen/application/first-loan-offer/product-number/{productNumber}/get';

export const SESSION_CALCULATOR_NAME = 'calculator';

export type SESSION_CALCULATOR_TYPE = {
  amount: number;
  term: number;
};

export const getDefaultCalculatorFromSession = () => {
  const sessionCalculatorData = sessionStorage?.getItem(
    SESSION_CALCULATOR_NAME,
  );
  const sessionCalculatorDataParsed: SESSION_CALCULATOR_TYPE | undefined =
    sessionCalculatorData && JSON.parse(sessionCalculatorData);
  return sessionCalculatorDataParsed;
};

type Props = {
  offerData?: ResponseOffer | undefined | null;
  constraints?: ResponseConstraints | undefined | null;
};
export const getClientConstraintsDefaultParams = ({
  offerData,
  constraints,
}: Props) => {
  const searchParams = new URLSearchParams(window.location.search);
  const sessionCalculatorDataParsed: SESSION_CALCULATOR_TYPE | undefined =
    getDefaultCalculatorFromSession();
  const parameters = constraints && getAmountAndTermCalculator({ constraints });

  return {
    amount: String(
      searchParams.get('amount') ||
        sessionCalculatorDataParsed?.amount ||
        offerData?.newPrincipal ||
        parameters?.amount ||
        App.config.fallbackAmount,
    ),
    term:
      searchParams.get('term') ||
      String(
        sessionCalculatorDataParsed?.term ||
          offerData?.term ||
          parameters?.term ||
          DEFAULT_TERM,
      ),
  };
};

export const setDefaultCalculatorFromSession = (
  amount: number,
  term: number,
) => {
  const sessionCalculatorDataParsed: SESSION_CALCULATOR_TYPE = { amount, term };
  sessionStorage.setItem(
    SESSION_CALCULATOR_NAME,
    JSON.stringify(sessionCalculatorDataParsed),
  );
};

export const clearCalculatorFromSession = () =>
  sessionStorage.removeItem(SESSION_CALCULATOR_NAME);
